import { InputLabel, Select } from "@material-ui/core";
import { Form } from "@unform/web";
import React, { Component } from "react";
import InputMask from "react-input-mask";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators, Dispatch } from "redux";
import DIRECTV_GO from "~/assets/DIRECTV_GO_LOGO_HORIZONTAL_RGB.svg";
import logoSky from "~/assets/log-SKY.svg";
import { ApplicationState } from "~/store";
import { AuthState } from "~/store/ducks/auth/types";
import {
  FormControlLGPD,
  StyledButton,
  StyledTextField,
  Wrapper,
  WrapperTest,
} from "./styles";

interface IProps {
  company?: string;
  nexAuth(): void;
  ownership: string;
  handleChangeOwnership: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleChangeIdentificationKey: (
    event: React.ChangeEvent<HTMLInputElement>
  ) => void;
  identificationKey: string;
  children: React.ReactNode;
  ownershiptypeerror: boolean;
  identificationkeyerror: boolean;
}

interface StateProps {
  language: any;
  auth: AuthState;
  common: any;
}

type Props = StateProps & IProps;

class SignIn extends Component<Props> {
  componentDidMount() {
    document.title = "Fazer login | Portal LGPD";
  }

  RInputMask = null;

  setLogo = (company: number) => {
    if (company === 1) {
      return logoSky;
    } else {
      return DIRECTV_GO;
    }
  };

  render() {
    const {
      company,
      nexAuth,
      children,
      ownership,
      handleChangeOwnership,
      handleChangeIdentificationKey,
      identificationKey,
      identificationkeyerror,
      ownershiptypeerror,
      language,
      auth,
      common,
    } = this.props;

    return (
      <WrapperTest>
        <Wrapper>
          <div className="content-small">
            <div className="vrio-corp">
              <span>Vrio Corp</span>
            </div>

            <div className="welcome">
              <h2>{language?.login?.bemVindo}</h2>
              <h1>{language?.login?.LGPDSystem}</h1>
            </div>
          </div>
          <div className="container-form">
            <Form onSubmit={nexAuth}>
              <div className="header">
                {auth.company?.country_company_id ? (
                  <img
                    src={this.setLogo(auth.company.country_company_id)}
                    alt={`logo ${auth.company?.company?.company_name?.toUpperCase()}`}
                  />
                ) : (
                  ""
                )}

                <h1>{language?.login?.fazerLogon}</h1>
                <h4>
                  Use sua conta{" "}
                  {auth.company?.company?.company_name?.toUpperCase()}
                </h4>
              </div>

              <StyledTextField
                id="country-company"
                disabled
                label={language?.login?.paisEmpresa}
                value={company}
                variant="outlined"
              />

              <FormControlLGPD
                variant="outlined"
                ownershiptypeerror={ownershiptypeerror}
              >
                <InputLabel htmlFor="outlined-ownershipType-native-simple">
                  {language?.login?.categoria}
                </InputLabel>
                <Select
                  native
                  value={ownership}
                  //@ts-ignore
                  onChange={handleChangeOwnership}
                  label={language?.login?.categoria}
                  inputProps={{
                    name: "ownershipType",
                    id: "ownershipType",
                  }}
                >
                  <option aria-label="ownershipType" value="" />
                  {!!common.categoria[0] &&
                    common.categoria?.map((el: any) => {
                      return (
                        <option
                          key={el.data_holder_cat_id}
                          value={el.data_holder_cat_id}
                        >
                          {el.data_holder_cat_name}
                        </option>
                      );
                    })}
                </Select>
              </FormControlLGPD>
              {ownership === "5" && auth.company.country_company_id === 2 ? (
                <StyledTextField
                  identificationkeyerror={identificationkeyerror}
                  value={identificationKey}
                  onChange={handleChangeIdentificationKey}
                  id="identification-key"
                  name="identification-key"
                  label="E-mail"
                  variant="outlined"
                />
              ) : (
                <InputMask
                  mask="999.999.999-99"
                  value={identificationKey}
                  ref={this.RInputMask}
                  onChange={handleChangeIdentificationKey}
                  disabled={false}
                  maskChar=""
                >
                  {() => (
                    <StyledTextField
                      identificationkeyerror={identificationkeyerror}
                      id="identification-key"
                      name="identification-key"
                      label={language?.login?.chaveDeIdentificacao}
                      variant="outlined"
                    />
                  )}
                </InputMask>
              )}

              <div className="ReCAPTCHA">{children}</div>

              <div className="StyledButton-align">
                <StyledButton type="submit" className="button-continue">
                  {!!language?.login?.continuar && language?.login?.continuar}
                </StyledButton>
              </div>
            </Form>

            <div className="nav-options">
              <p>
                <Link to={`/${auth?.company?.path_alias_nm}/contactdpo`}>
                  {language?.login?.solicitarAjudaAoDPO}
                </Link>
              </p>
            </div>

            <p className="footer">
              {language?.login?.politicaGoogle.parte_1}{" "}
              <a
                href="https://policies.google.com/privacy?hl=pt"
                target="_blank"
                rel="noopener noreferrer"
              >
                {language?.login?.politicaGoogle.parte_2}
              </a>{" "}
              {language?.login?.politicaGoogle.parte_3}{" "}
              <a
                href="https://policies.google.com/terms?hl=pt"
                target="_blank"
                rel="noopener noreferrer"
              >
                {language?.login?.politicaGoogle.parte_4}
              </a>{" "}
              {language?.login?.politicaGoogle.parte_5}
            </p>
          </div>
        </Wrapper>
      </WrapperTest>
    );
  }
}

const mapStateToProps = (state: ApplicationState) => ({
  language: state.language.data,
  auth: state.auth,
  common: state.common,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  ...bindActionCreators({}, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);
